import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import { nodeUtils } from '../../../utils/nodeUtils.js';
import UpdateForm from '../forms/update-form';
import { updateValidationSchema } from '../schema/update.js';

export default function UpdateNode({ data, id, type }) {
  return (
    <NodeProvider
      key={data['data-frame']}
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Update Node Details',
        altText: 'Update Node',
        defaultLabel: nodeUtils.getNodeName(data['data-frame']) || 'Update Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={UpdateForm} schemaResolver={updateValidationSchema} />
    </NodeProvider>
  );
}
